<script lang="ts" setup>
import { UiButton } from "@packages/component-library";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="not-found container">
    <div class="not-found__wrapper">
      <div class="not-found__info">
        <span>404</span>
        <h5>{{ t("notFound.title") }}</h5>
        <p>{{ t("notFound.description") }}</p>
        <div class="not-found__actions">
          <UiButton
            :label="t('system.goHome')"
            size="l"
            :to="{ name: 'HomeView' }"
            data-test-id="notFound-button-home"
          />
          <UiButton
            :label="t('nav.support')"
            size="l"
            color="secondary"
            href="https://support.rc.today/sign-in?source=cs"
            data-test-id="notFound-button-support"
            target="_blank"
          />
        </div>
      </div>

      <img src="@/assets/images/page-not-found.svg" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-items: center;
  flex-flow: column;
  padding: calc($base-space * 10) 0;

  @media (max-width: 1239px) {
    padding: 0;
  }

  &__wrapper {
    width: 820px;
    display: grid;
    grid-template-columns: 484px auto;
    gap: calc($base-space * 4);
    align-items: center;
    padding: calc($base-space * 10) 0;

    @media (max-width: 1239px) {
      width: auto;
      max-width: 400px;
      display: flex;
      flex-flow: column-reverse;
      gap: calc($base-space * 4);
      justify-content: center;
    }
  }

  &__info {
    @media (max-width: 1239px) {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-items: center;
      margin: calc($base-space * 4) 0 0;
    }

    > span {
      @include body-l();
      color: var(--color-semantic-content-normal-static-dark);
      padding: calc($base-space * 1.5) ($base-space * 3);
      background-color: var(--color-semantic-background-normal-secondary);
      border-radius: 999px;
    }

    > h5 {
      margin: calc($base-space * 8) 0 0;
      @include h3();
      color: var(--color-semantic-content-normal-primary);

      @media (max-width: 1239px) {
        text-align: center;
        margin: calc($base-space * 3) 0 0;
      }
    }

    > p {
      margin: calc($base-space * 2) 0 0;
      @include body-m();
      color: var(--color-semantic-content-normal-secondary);

      @media (max-width: 1239px) {
        text-align: center;
      }
    }
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: calc($base-space * 4);

    padding: 0 ($base-space * 12.5);

    @media (max-width: 1239px) {
      padding: ($base-space * 5) 0;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: calc($base-space * 3);
    margin: calc($base-space * 8) 0 0;

    @media (max-width: 1239px) {
      width: 400px;
      flex-flow: column;
      gap: calc($base-space * 2);

      > a {
        width: 100%;
      }
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }
}
</style>
